import { render, staticRenderFns } from "./correct-sign.vue?vue&type=template&id=e3d0f4fc&"
import script from "./correct-sign.vue?vue&type=script&lang=js&"
export * from "./correct-sign.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports